var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNocategoriesfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 295,
    viewBox: "0 0 352 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_39068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.617 294.948H41.7812L80.5132 75.7773H348.349L309.617 294.948Z",
    fill: "#45A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.183 53.0742H84.5222L80.5137 75.7764H174.319L172.183 53.0742Z",
    fill: "#45A4AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.617 294.948H41.7812L80.5132 75.7773H348.349L309.617 294.948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.183 53.0742H84.5222L80.5137 75.7764H174.319L172.183 53.0742Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.7522 37.6458C78.9156 34.542 78.7226 31.4383 78.6797 28.3346C78.7011 25.2309 78.8942 22.1272 79.7522 19.0234C80.6102 22.1272 80.8033 25.2309 80.8247 28.3346C80.7818 31.4383 80.5888 34.542 79.7522 37.6458Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7469 43.1237C58.4517 40.8548 56.7357 38.2648 55.1484 35.5892C53.6254 32.8921 52.2311 30.1095 51.416 26.9844C53.7112 29.2533 55.4272 31.8433 57.0146 34.5189C58.5375 37.2159 59.9318 39.9986 60.7469 43.1237Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0409 57.358C43.9306 56.5446 41.142 55.1533 38.4178 53.6336C35.7365 52.0496 33.141 50.3372 30.8673 48.0469C33.9776 48.8603 36.7662 50.2516 39.4904 51.7713C42.1717 53.3553 44.7671 55.0677 47.0409 57.358Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3005 76.5175C39.1902 77.3523 36.0799 77.545 32.9696 77.5878C29.8593 77.5664 26.749 77.3737 23.6387 76.5175C26.749 75.6613 29.8593 75.4687 32.9696 75.4473C36.0799 75.4901 39.1902 75.6827 42.3005 76.5175Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7927 95.4805C45.519 97.7708 42.9235 99.4832 40.2422 101.067C37.5394 102.587 34.7509 103.978 31.6191 104.792C33.8929 102.501 36.4884 100.789 39.1697 99.2049C41.8724 97.6852 44.661 96.2939 47.7927 95.4805Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0555 109.18C61.2404 112.283 59.8461 115.066 58.3232 117.784C56.7358 120.46 55.0198 123.05 52.7246 125.319C53.5397 122.215 54.934 119.433 56.457 116.714C58.0443 114.039 59.7603 111.449 62.0555 109.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2756 113.912C82.1122 117.016 82.3053 120.12 82.3482 123.223C82.3267 126.327 82.1337 129.431 81.2756 132.534C80.4176 129.431 80.2246 126.327 80.2031 123.223C80.246 120.12 80.4391 117.016 81.2756 113.912Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.281 108.41C102.576 110.679 104.292 113.269 105.88 115.945C107.403 118.642 108.797 121.424 109.612 124.549C107.317 122.281 105.601 119.691 104.014 117.015C102.491 114.318 101.096 111.535 100.281 108.41Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.988 94.1758C117.099 94.9892 119.887 96.3805 122.611 97.9002C125.293 99.4842 127.888 101.197 130.162 103.487C127.052 102.674 124.263 101.282 121.539 99.7625C118.858 98.1785 116.262 96.4661 113.988 94.1758Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.729 75.0195C121.839 74.1847 124.949 73.992 128.059 73.9492C131.17 73.9706 134.28 74.1633 137.39 75.0195C134.28 75.8757 131.17 76.0683 128.059 76.0897C124.949 76.0469 121.839 75.8543 118.729 75.0195Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.236 56.0533C115.51 53.763 118.106 52.0506 120.787 50.4666C123.49 48.9469 126.278 47.5556 129.41 46.7422C127.136 49.0325 124.541 50.7449 121.859 52.3289C119.157 53.8486 116.368 55.24 113.236 56.0533Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9724 42.3757C99.7875 39.2719 101.182 36.4893 102.705 33.7709C104.292 31.0953 106.008 28.5053 108.303 26.2363C107.488 29.34 106.094 32.1227 104.571 34.8411C102.984 37.5167 101.268 40.1067 98.9724 42.3757Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.231 294.949H40.8148L2.70703 83.7344H271.123L309.231 294.949Z",
    fill: "#6EB5BC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_537_39068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.805 239.554C219.155 220.696 223.732 185.797 205.028 161.605C186.324 137.412 151.421 133.088 127.071 151.945C102.72 170.803 98.1431 205.702 116.847 229.894C135.552 254.086 170.454 258.411 194.805 239.554Z",
    fill: "#0D8390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.763 212.69L168.294 195.464L185.669 176.89C187.625 174.799 187.524 171.482 185.444 169.542C183.364 167.602 180.043 167.727 178.086 169.818L160.711 188.392L142.242 171.166C140.162 169.226 136.841 169.351 134.884 171.443C132.927 173.534 133.029 176.851 135.109 178.791L153.578 196.017L136.203 214.59C134.247 216.682 134.348 219.999 136.428 221.939C138.508 223.879 141.829 223.754 143.786 221.662L161.161 203.089L179.63 220.315C181.71 222.255 185.031 222.13 186.988 220.038C188.945 217.946 188.843 214.63 186.763 212.69Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_39068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 351.875,
    height: 294.679,
    fill: "white",
    transform: "translate(0.0625 0.269531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_537_39068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.745,
    height: 111.525,
    fill: "white",
    transform: "matrix(0.731297 0.682059 -0.683152 0.730276 158.537 117.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocategoriesfound);
export default __webpack_public_path__ + "static/media/Nocategoriesfound.ed8dbb33a403d320b1018757021dbaec.svg";
export { ForwardRef as ReactComponent };